export const screen = {
    conference: {
        breakoutRooms: 'Breakout Rooms',
        carmode: 'Car Mode',
        chat: 'Chat',
        chatandpolls: {
            main: 'Chat and Polls',
            tab: {
                chat: 'Chat',
                polls: 'Polls'
            }
        },
        container: 'Conference container',
        gifsMenu: 'GIPHY',
        invite: 'Invite',
        liveStream: 'Live stream',
        main: 'Conference',
        participants: 'Participants',
        root: 'Conference root',
        recording: 'Recording',
        salesforce: 'Link to Salesforce',
        security: 'Security Options',
        sharedDocument: 'Shared document',
        speakerStats: 'Speaker Stats',
        subtitles: 'Subtitles',
        whiteboard: 'Whiteboard'
    },
    connecting: 'Connecting',
    dialInSummary: 'Dial-In Info',
    preJoin: 'Pre-Join',
    lobby: {
        chat: 'Lobby chat',
        main: 'Lobby',
        root: 'Lobby root'
    },
    settings: {
        language: 'Language',
        main: 'Settings',
        profile: 'Profile'
    },
    unsafeRoomWarning: 'Unsafe Room Warning',
    auth: {
        login: 'Login',
        resetPassword: 'Reset Password'
    },
    vrs: {
        home: 'VRS Home',
        callbackReview: 'Review Call',
        callHistory: 'VRS Call History',
        contacts: 'VRS Contacts',
        contactDetail: 'VRS Contact Detail',
        settings: 'VRS Settings',
        voicemail: 'VRS Voicemail'
    },
    vri: {
        console: 'VRI Console',
        schedule: 'VRI Schedule',
        settings: 'VRI Settings',
        usage: 'VRI Usage'
    },
    relay: {
        home: 'Relay Home'
    },
    interpreter: {
        home: 'Interpreter Home',
        schedule: 'Interpreter Schedule',
        settings: 'Interpreter Settings',
        earnings: 'Interpreter Earnings',
        jobs: 'Interpreter Jobs',
        callHistory: 'Interpreter Call History',
        performance: 'Interpreter Performance',
        credentials: 'Interpreter Credentials'
    },
    welcome: {
        main: 'Welcome',
        tabs: {
            calendar: 'Calendar',
            recent: 'Recent'
        }
    }
};
